/* @flow */
import { Record } from 'immutable';

export type StatusRecord = Record<{
  loading: boolean,
  complete: boolean,
}>;

export const Status = Record({
  loading: false,
  complete: false,
});

export type DateRange = {
  dateSince: number,
  dateUntil: number,
};

export type ReindexOptionsRecord = Record<{
  dateSince: any,
  dateUntil: any,
  enclaveGuid: string,
}>;

export const ReindexOptions = Record({
  dateSince: null,
  dateUntil: null,
  enclaveGuid: null,
});



// WEBPACK FOOTER //
// ./src/app/modules/devtasks/types.js